(function () {
  const GALLERY_SELECTOR = 'media-gallery[data-magcheer-variant-media-gallery]';

  function slugify(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function expandToken(token) {
    const aliases = {
      blue: ['blue', 'light-blue'],
      'gunmetal-gray': ['gunmetal-gray', 'gunmetal'],
      navy: ['navy', 'navy-blue'],
      purple: ['purple', 'lavender'],
    };

    return aliases[token] || [token];
  }

  function getVariantMap(gallery) {
    const mapScript = gallery.querySelector('script[id^="MagcheerVariantMediaMap"]');
    if (!mapScript) return null;

    try {
      return JSON.parse(mapScript.textContent);
    } catch (error) {
      console.warn('Unable to parse Magcheer variant media map', error);
      return null;
    }
  }

  function getCurrentVariant(gallery, variantMap, variantFromEvent) {
    if (variantFromEvent?.id) return variantFromEvent;

    const productInfo = gallery.closest('product-info');
    const variantId = productInfo?.querySelector('input[name="id"]')?.value;

    return variantMap?.variants?.find((variant) => String(variant.id) === String(variantId));
  }

  function getVariantTokens(variant) {
    const rawTokens = [variant?.title, ...(variant?.options || [])];
    const tokens = rawTokens.map(slugify).filter(Boolean).flatMap(expandToken);

    return Array.from(new Set(tokens));
  }

  function getMatchingTokens(slides, variant) {
    const commonGalleryToken = 'magcheer-common-gallery';
    const titleToken = slugify(variant?.title);

    if (titleToken) {
      const hasExactVariantMedia = slides.some((slide) => (
        !slide.dataset.magcheerMediaFilter.includes(commonGalleryToken)
        && slide.dataset.magcheerMediaFilter.includes(titleToken)
      ));

      if (hasExactVariantMedia) return [titleToken];
    }

    return getVariantTokens(variant);
  }

  function setElementVisible(element, visible) {
    element.hidden = !visible;
    element.style.display = visible ? '' : 'none';
  }

  function updateCounter(gallery, count) {
    const total = gallery.querySelector('.slider-counter--total');
    const current = gallery.querySelector('.slider-counter--current');

    if (total) total.textContent = String(count);
    if (current) current.textContent = count > 0 ? '1' : '0';
  }

  function activateFirstVisibleMedia(gallery) {
    const firstVisibleSlide = gallery.querySelector('li[data-media-id]:not([hidden])');
    if (!firstVisibleSlide) return;

    gallery.setActiveMedia?.(firstVisibleSlide.dataset.mediaId, false);

    const firstVisibleThumbnail = gallery.querySelector('li[data-target]:not([hidden])');
    gallery.querySelectorAll('li[data-target] button[aria-current]').forEach((button) => {
      button.removeAttribute('aria-current');
    });
    firstVisibleThumbnail?.querySelector('button')?.setAttribute('aria-current', 'true');
  }

  function filterGallery(gallery, variantFromEvent) {
    const variantMap = getVariantMap(gallery);
    const variant = getCurrentVariant(gallery, variantMap, variantFromEvent);
    const slides = Array.from(gallery.querySelectorAll('li[data-media-id][data-magcheer-media-filter]'));
    const thumbnails = Array.from(gallery.querySelectorAll('li[data-target][data-magcheer-media-filter]'));
    const modalMedia = Array.from(
      gallery
        .closest('product-info')
        ?.querySelectorAll('product-modal [data-media-id][data-magcheer-media-filter]') || []
    );
    const tokens = getMatchingTokens(slides, variant);

    if (!tokens.length || !slides.length) return;

    const matchingMediaIds = new Set(
      slides
        .filter((slide) => (
          slide.dataset.magcheerMediaFilter.includes('magcheer-common-gallery')
          || tokens.some((token) => slide.dataset.magcheerMediaFilter.includes(token))
        ))
        .map((slide) => slide.dataset.mediaId)
    );

    if (!matchingMediaIds.size) {
      [...slides, ...thumbnails, ...modalMedia].forEach((element) => setElementVisible(element, true));
      updateCounter(gallery, slides.length);
      return;
    }

    slides.forEach((slide) => setElementVisible(slide, matchingMediaIds.has(slide.dataset.mediaId)));
    thumbnails.forEach((thumbnail) => setElementVisible(thumbnail, matchingMediaIds.has(thumbnail.dataset.target)));
    modalMedia.forEach((media) => {
      const shouldShow =
        media.dataset.magcheerMediaFilter.includes('magcheer-common-gallery')
        || tokens.some((token) => media.dataset.magcheerMediaFilter.includes(token));
      setElementVisible(media, shouldShow);
    });

    updateCounter(gallery, matchingMediaIds.size);
    activateFirstVisibleMedia(gallery);
  }

  function filterAllGalleries(variantFromEvent) {
    document.querySelectorAll(GALLERY_SELECTOR).forEach((gallery) => filterGallery(gallery, variantFromEvent));
  }

  document.addEventListener('DOMContentLoaded', () => filterAllGalleries());
  document.addEventListener('product-info:loaded', () => window.setTimeout(() => filterAllGalleries(), 0));
  document.addEventListener('change', (event) => {
    if (event.target?.closest?.('variant-selects')) {
      window.setTimeout(() => filterAllGalleries(), 250);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      window.setTimeout(() => filterAllGalleries(event?.data?.variant), 0);
    });
  }
})();
